import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en';
import fi from './locales/fi';

const resources = {
  en,
  fi,
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fi',
    interpolation: {
      escapeValue: false,
    },
    fallbackLng: 'en',
  });

export default i18n;
